import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Tooltip,
  Stack,
  Typography,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../../common/SettingsAccordion";
import { IProductParams, webTechs } from "../../../model";

interface IProps {
  name: string;
  accordionSettings: any;
  handleAccordionSettings: (name: string) => void;
  snackbarShowMessage: any;
  chatbotSettings: any;
  setChatbotSettings: (values: any) => void;
  handleBasicSettingsValidation: () => void;
  productParams: IProductParams;
}

const BasicDetails = ({
  accordionSettings,
  chatbotSettings,
  handleAccordionSettings,
  name,
  setChatbotSettings,
  snackbarShowMessage,
  handleBasicSettingsValidation,
  productParams,
}: IProps) => {
  const [loading, setLoading] = useState(false);
  const [deleteFileName, setDeleteFileName] = useState("");

  function formatFileSize(bytes: number, decimalPoint: number) {
    if (bytes == 0) return "0 Bytes";
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleLogoChange = (url: string, dataInfo: any) => {
    const tempChatbotSettings = { ...chatbotSettings };

    tempChatbotSettings.logo = url;
    tempChatbotSettings.logoReq = dataInfo;
    setChatbotSettings(tempChatbotSettings);
  };

  const handleUpload = (event: any) => {
    const file = event.target.files[0];
    const formUpload = new FormData();

    const size = file.size;
    const cur = formatFileSize(size, 2);
    if (!cur.includes("Bytes") && !cur.includes("KB")) {
      snackbarShowMessage(
        "You must give an image with less then 1MB",
        "error",
        3000
      );
    } else {
      formUpload.append("file", file);
      formUpload.append("fileName", file.name);
      setLoading(true);
      const reader = new FileReader();
      reader.onload = function () {
        const base64String = String(reader.result).split("base64,")[1];
        const extension = file.name.split(".")[1];
        const dataInfo = {
          file: base64String,
          fileName: `logo.${extension}`,
          deleteFileName: "",
        };
        if (deleteFileName && deleteFileName != "") {
          dataInfo.deleteFileName = deleteFileName;
        }
        const resultString = URL.createObjectURL(file);
        handleLogoChange(resultString, dataInfo);
      };
      reader.onerror = function (event) {
        reader.abort();
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteLogo = (logo: string) => {
    setLoading(true);
    const filenames: string[] = logo.split("/");
    const filename = filenames[filenames.length - 1];
    const dataInfo = {
      deleteFileName: filename,
    };
    setDeleteFileName(filename);
    handleLogoChange("", dataInfo);
  };

  const handleChange = (e: any) => {
    const { value } = e.target;
    setChatbotSettings({ ...chatbotSettings, ["name"]: value });
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography className="title-sm1">
            <Typography component="label">Account name</Typography>
            <Typography style={{ fontSize: "12px" }}>
              {productParams.name}
            </Typography>
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography className="title-sm1">
            <Typography component="label">Version</Typography>
            <Typography style={{ fontSize: "12px" }}>
              {productParams.version}
            </Typography>
          </Typography>
        </Grid>
        {/* <Grid item xs={12} md={3}>
            <Typography className="title-sm1">
              <Typography component="label">Platform</Typography>
              <Typography style={{fontSize: "12px"}}>
                {productParams &&
                  productParams.products &&
                  productParams.products[0] &&
                  productParams.products[0].platform}
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography className="title-sm1">
              <Typography component="label">Technology</Typography>
              <Typography style={{fontSize: "12px"}}>
                {webTechs.find((e:any) => e.value == productParams?.products[0]?.technology)?.name}
              </Typography>
            </Typography>
          </Grid> */}
      </Grid>
      <br></br>
    </Box>
    // <Accordion
    //   expanded={accordionSettings[name]}
    //   onChange={() => handleAccordionSettings(name)}
    // >
    //   <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
    //     Basic Details
    //     {/* <Tooltip title="Basic Details Help" placement="bottom">
    //       <HelpIcon sx={{ mx: 1, fontSize: "20px" }} />
    //     </Tooltip> */}
    //   </AccordionSummary>
    //   <AccordionDetails>
    //     <Grid container spacing={2}>
    //       <Grid item xs={12} md={3}>
    //         <Typography className="title-sm1">
    //           <Typography component="label">Product name</Typography>
    //           <Typography style={{fontSize: "12px"}}>
    //             {productParams &&
    //               productParams.products &&
    //               productParams.products[0] &&
    //               productParams.products[0].name}
    //           </Typography>
    //         </Typography>

    //       </Grid>
    //       <Grid item xs={12} md={3}>
    //         <Typography className="title-sm1">
    //           <Typography component="label">Product version</Typography>
    //           <Typography style={{fontSize: "12px"}}>
    //             {productParams &&
    //               productParams.products &&
    //               productParams.products[0] &&
    //               productParams.products[0].version}
    //           </Typography>
    //         </Typography>
    //       </Grid>
    //       <Grid item xs={12} md={3}>
    //         <Typography className="title-sm1">
    //           <Typography component="label">Platform</Typography>
    //           <Typography style={{fontSize: "12px"}}>
    //             {productParams &&
    //               productParams.products &&
    //               productParams.products[0] &&
    //               productParams.products[0].platform}
    //           </Typography>
    //         </Typography>
    //       </Grid>
    //       <Grid item xs={12} md={3}>
    //         <Typography className="title-sm1">
    //           <Typography component="label">Technology</Typography>
    //           <Typography style={{fontSize: "12px"}}>
    //             {productParams &&
    //               productParams.products &&
    //               productParams.products[0] &&
    //               productParams.products[0].technology}
    //           </Typography>
    //         </Typography>
    //       </Grid>
    //     </Grid>

    //     <Grid
    //       item
    //       sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
    //       xs={12}
    //       md={12}
    //     // className="acc-prod-footer"
    //     >
    //       {/* <>
    //         <div></div>
    //       </>
    //       <Tooltip title="Go to General Settings" placement="bottom">
    //         <Button
    //           size="small"
    //           className="nextbtn guideTourGeneralSettings"
    //           onClick={handleBasicSettingsValidation}
    //         >
    //           &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
    //           <span>Go to General Settings</span>
    //           <KeyboardArrowRight />
    //         </Button>
    //       </Tooltip>{" "} */}
    //     </Grid>
    //   </AccordionDetails>
    // </Accordion>
  );
};

export default withSnackbar(BasicDetails);
